import React from "react";
import { ControlLabel, FormControl, Button } from "react-bootstrap";
import moment from 'moment';

export default class PaystubSearchPanel extends React.Component {
    constructor(props) {
        super(props);
        this.getTimePeriodList = this.getTimePeriodList.bind(this);
    }

    getTimePeriodList() {
        let now = moment();
        let y = now.year();
        let yearList = [];
        let monthList = [];
        for (let i = 0; i < 8; i++) {
            yearList.push(<option key={y - i} value={y - i}>{y - i}</option>);
        }
        for (let i = 0; i < 12; i++) {
            monthList.push(<option key={moment(now.month(i)).format("MM")} value={moment(now.month(i)).format("MM")}>{moment(now.month(i)).format("MMMM")}</option>);
        }       
        return {
            year: yearList,
            month: monthList        
        };
    }

    render() {
        const timePeriod = this.getTimePeriodList();
        const self = this;
        const inputs = {};
        var currentMonth = ((new Date()).getMonth() + 1);
        currentMonth = currentMonth < 10 ? "0" + currentMonth : currentMonth.toString();
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-4">
                        <ControlLabel>Year</ControlLabel>
                        <FormControl componentClass="select" inputRef={node => inputs.year = node}>
                            {timePeriod.year}
                            </FormControl>

                    </div>
                    <div className="col-md-4">
                        <ControlLabel>From</ControlLabel>
                        <FormControl componentClass="select" inputRef={node => inputs.fromDate = node} defaultValue={currentMonth}>
                            {timePeriod.month}
                            </FormControl>
                    </div>
                    <div className="col-md-4">
                        <ControlLabel>To</ControlLabel>
                        <FormControl componentClass="select" inputRef={node => inputs.toDate = node}  defaultValue={currentMonth}>
                            {timePeriod.month}
                          </FormControl>
                    </div>
                </div>
                <div className="row ap-top-margined">
                    <div className="col-md-12">
                        <Button className="btn-info ap-fullsize" onClick={() => {
                            if (this.props.onSearchClick) this.props.onSearchClick({
                                year: inputs.year.value,
                                fromDate: inputs.fromDate.value,
                                toDate: inputs.toDate.value
                            });
                        }}>SEARCH</Button>
                    </div>
                </div>
            </div >
        );
    }
}